/**
 * People/Auth RPC definitions
 *
 * Authenticated endpoints for user operations.
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { Person } from "@fm/db/frontend";
import { Schema } from "effect";
import { AuthMiddleware, EnsureUserAuthMiddleware } from "../auth.tags.ts";
import { ClerkError, DatabaseError, RecordNotFoundError, Unauthorized } from "../errors.ts";

// ============================================================================
// RPC Group
// ============================================================================

/**
 * People RPC group containing user-related endpoints
 *
 * @since 1.0.0
 */
export class PeopleRpcs extends RpcGroup.make(
  Rpc.make("me", {
    success: Person.json,
    error: Schema.Union(Unauthorized, RecordNotFoundError, DatabaseError),
  }).middleware(AuthMiddleware),
  Rpc.make("ensureUser", {
    success: Person.json,
    error: Schema.Union(Unauthorized, ClerkError, DatabaseError),
  }).middleware(EnsureUserAuthMiddleware),
) {}
